interface IconProps {
  color?: string;
  size?: string | number;
}

const RarityRareIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M2.74869 13.8517C2.23986 13.3429 1.98545 12.7262 1.98545 12.0015C1.98545 11.2768 2.23986 10.66 2.74869 10.1512L10.1497 2.75016C10.6586 2.24134 11.2753 1.98693 12 1.98693C12.7247 1.98693 13.3414 2.24134 13.8503 2.75016L21.2513 10.1512C21.7601 10.66 22.0145 11.2768 22.0145 12.0015C22.0145 12.7262 21.7601 13.3429 21.2513 13.8517L13.8503 21.2528C13.3414 21.7616 12.7247 22.016 12 22.016C11.2753 22.016 10.6586 21.7616 10.1497 21.2528L2.74869 13.8517Z" />
    </svg>
  );
};

export default RarityRareIcon;
